/*
	GETTERS
*/
//------------------------------------------------------------
// SHOW SYSTEM
//------------------------------------------------------------

const showSystem = (state) => {
    return state.showSystem;
}

//------------------------------------------------------------
// GET LOCAL FILE SYSTEM (PLAYER)
//------------------------------------------------------------

const getLocalFileSystem = (state) => {
    return state.fileSystem.local;
}

// FOR TESTING PURPOSES ONLY
const getServerFileSystem = (state) => {
    return state.fileSystem.local.SERVER_TEMPLATE;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	showSystem,
	getLocalFileSystem
}
//===========================================
//
//===========================================